import PropTypes from 'prop-types';
import { useI18n } from '../../../../../context/I18nContext';
import { ROOM_SETTINGS_PAGES } from '../../../../../constants/roomSettings';
import './SideBar.css';

const SideBar = ({
  currentPage = ROOM_SETTINGS_PAGES.NOTIFICATIONS,
  onPageChange = () => {},
  canConfigure = false,
  userPowerLevel = 0,
}) => {
  const { t } = useI18n();
  
  // Only show Security and Permissions pages if user has configure permissions
  // Permissions page additionally requires admin level (power level >= 100)
  const showPermissions = canConfigure && userPowerLevel >= 100;
  
  return (
    <div className="room-settings-sidebar">
      {canConfigure && (
        <button
          className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.SECURITY ? 'active' : ''}`}
          onClick={() => onPageChange(ROOM_SETTINGS_PAGES.SECURITY)}
        >
          <ion-icon name="shield-checkmark-outline" />
          <span>{t('RoomSettings.sidebarSecurity')}</span>
        </button>
      )}
      {showPermissions && (
        <button
          className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.PERMISSIONS ? 'active' : ''}`}
          onClick={() => onPageChange(ROOM_SETTINGS_PAGES.PERMISSIONS)}
        >
          <ion-icon name="people-outline" />
          <span>{t('RoomSettings.sidebarPermissions')}</span>
        </button>
      )}
      <button
        className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.NOTIFICATIONS ? 'active' : ''}`}
        onClick={() => onPageChange(ROOM_SETTINGS_PAGES.NOTIFICATIONS)}
      >
        <ion-icon name="notifications-outline" />
        <span>{t('RoomSettings.sidebarNotifications')}</span>
      </button>
      <button
        className={`room-settings-sidebar-button ${currentPage === ROOM_SETTINGS_PAGES.DETAILS ? 'active' : ''}`}
        onClick={() => onPageChange(ROOM_SETTINGS_PAGES.DETAILS)}
      >
        <ion-icon name="information-circle-outline" />
        <span>{t('RoomSettings.sidebarDetails')}</span>
      </button>
    </div>
  );
};

SideBar.propTypes = {
  currentPage: PropTypes.string,
  onPageChange: PropTypes.func,
  canConfigure: PropTypes.bool,
  userPowerLevel: PropTypes.number,
};

export default SideBar;
